// Factory for a per-model cache map. The previous Proxy implementation
// intercepted reads and returned `undefined` when the toggle was off — but
// every model relies on a write-then-read pattern (fetch writes a value, the
// next call reads it within the same flow). Blocking reads broke that, e.g.
// map signal coloring couldn't pull the metrics it had just stored.
//
// The "off" semantics is now enforced explicitly in each model's cache-hit
// short-circuit, which guards `if (cached) return cached` on
// `isModelCacheEnabled(modelKey, category)`. That forces a refetch when the
// toggle is off without blocking the underlying read.
//
// The (modelKey, category) arguments are still accepted so call sites don't
// have to change and so future per-bucket extensions stay easy to wire up.
export function makeBypassableCache(_modelKey, _category) {
	return {}
}
